export const type = {
  anualList: '[Internaciones Iniciado Autorizado Anual] anualList',
  mensualList: '[Internaciones Iniciado Autorizado Mensual] mensualList',
};
